export default __webpack_public_path__ + "static/media/declined-request.e8f30a22.svg";